import type { SVGProps } from 'react';

const HeatStrokeSvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    viewBox="0 0 32 32"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 10.7998C18.2088 10.8 19.9998 12.591 20 14.7998V18.7285C21.2273 19.8271 22 21.4234 22 23.2002C21.9999 26.5137 19.3135 29.2 16 29.2002C12.6865 29.2 10.0001 26.5137 10 23.2002C10 21.4235 10.7728 19.8271 12 18.7285V14.7998C12.0002 12.5908 13.791 10.7998 16 10.7998ZM16 12.3994C14.6749 12.3994 13.5998 13.4743 13.5996 14.7998V19.4434L13.0674 19.9209C12.1647 20.729 11.5997 21.8977 11.5996 23.2002C11.5997 25.6299 13.5701 27.6004 16 27.6006C18.4298 27.6004 20.4003 25.63 20.4004 23.2002C20.4003 21.8975 19.8352 20.7289 18.9326 19.9209L18.4004 19.4434V14.7998C18.4002 13.4744 17.325 12.3996 16 12.3994ZM16 14.4004C16.4417 14.4004 16.7996 14.7585 16.7998 15.2002V20.9395C17.7316 21.2691 18.4003 22.1556 18.4004 23.2002C18.4002 24.5255 17.3254 25.6006 16 25.6006C14.6748 25.6004 13.5998 24.5254 13.5996 23.2002C13.5997 22.1557 14.2687 21.2692 15.2002 20.9395V15.2002C15.2004 14.7586 15.5584 14.4006 16 14.4004Z"
      fill="currentColor"
    />
    <path
      d="M19 7C21.2091 7 23 8.79086 23 11C23 12.8638 21.7252 14.43 20 14.874V14.7998C19.9999 12.5909 18.2089 10.8 16 10.7998C15.6553 10.7998 15.3201 10.8428 15.001 10.9248C15.0411 8.75037 16.816 7 19 7Z"
      fill="currentColor"
    />
    <path
      d="M19 3V4"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M24 16L25 17"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M26 11H27"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11 11H12"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M24 6L25 5"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14 6L13 5"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default HeatStrokeSvgIcon;
